import { StrictMode } from "react";
import { HelmetProvider } from 'react-helmet-async';
import { createRoot } from "react-dom/client";
import {ApplicationContextStoreProvider}  from "@8d-xyz/ui-react_application_f-container"
import ApplicationContextStore from './ApplicationContextStore';
import { TranslationProvider } from "./lib/language/TranslationProvider"; 
import appConfigObj from './ApplicationContextConfig.json';
import sessionData from './lib/session/sessionData.json';
import {appInit} from './ApplicationStart';
//import { UserSessionProvider } from '@8d-xyz/ui-react_account_access-widget';
import { UserSessionProvider } from './lib/session/UserSession'; 
import eventDispatcher from "./events/dispatcher";
import App from "./App";
import "./index.css";


async function startApp(){
  //preload app metadata for react app loaded canbe accessed via userSession in sessionStore
  sessionData.APP_META = await eventDispatcher.APP_INFO({ app_name: "DIGITSTASH", info_type: "all" }, 
    (data) => {}
  );
        
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    
    <TranslationProvider>
    <HelmetProvider>
      <ApplicationContextStoreProvider
        appContextStore = {ApplicationContextStore}
        //configUrl="/data/dev/ApplicationContextConfig.json"
        appConfigObj={appConfigObj}
        appInit={appInit} 
      >
        <UserSessionProvider >
        <App/>
       </UserSessionProvider>
      </ApplicationContextStoreProvider>
      </HelmetProvider>
      </TranslationProvider>
     
  </StrictMode>
);
}
startApp();
